import { useState, useRef, useEffect } from "react";

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

const SOCIETE_MAP = {
  "1": "LOGIMES", "2": "KARMEX", "3": "TPM",
  "4": "LPE", "5": "SEKKINOX", "6": "SODEMO", "7": "WMT", "8": "AMP"
};

export default function CompanyEdit() {
  const logoRef = useRef();
  const [logoPreview, setLogoPreview] = useState(null);
  const [saved, setSaved] = useState(false);
  const sid = getCookie("societe_id");
  const societeNom = SOCIETE_MAP[sid] || "Ma Société";

  const [form, setForm] = useState({
    nom: societeNom,
    adresse: "",
    telephone: "",
    logo: null,
  });

  useEffect(() => {
    const savedLogo = localStorage.getItem(`logo_${sid}`);
    if (savedLogo) setLogoPreview(savedLogo);
    
    const savedAdresse   = localStorage.getItem(`adresse_${sid}`);
    const savedTelephone = localStorage.getItem(`telephone_${sid}`);
    if (savedAdresse)   setForm(prev => ({ ...prev, adresse:   savedAdresse   }));
    if (savedTelephone) setForm(prev => ({ ...prev, telephone: savedTelephone }));
  }, []);

  const handleLogo = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setForm({ ...form, logo: file });
    setLogoPreview(URL.createObjectURL(file));
  };

  const handleSave = () => {
    localStorage.setItem(`adresse_${sid}`,   form.adresse);
    localStorage.setItem(`telephone_${sid}`, form.telephone);
    if (form.logo) {
      const reader = new FileReader();
      reader.onload = (e) => {
        localStorage.setItem(`logo_${sid}`, e.target.result);
      };
      reader.readAsDataURL(form.logo);
    }
    setSaved(true);
    setTimeout(() => {
      window.location.href = "/home";
    }, 1500);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0efff", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Outfit', sans-serif", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 8px 40px rgba(108,99,255,0.10)", padding: "48px 44px", width: "100%", maxWidth: 500 }}>
        
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#6c63ff", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>
            ✏️ MODIFIER MA SOCIÉTÉ
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#1a1a2e" }}>{societeNom}</div>
        </div>

        {saved && (
          <div style={{ background: "#f0fff4", border: "1.5px solid #6ee7b7", borderRadius: 10, padding: "12px 16px", color: "#065f46", fontSize: 13, marginBottom: 20 }}>
            ✅ Modifications sauvegardées ! Redirection...
          </div>
        )}

        {/* Logo */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#444", marginBottom: 8, display: "block" }}>🖼️ Logo de la société</label>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div
              onClick={() => logoRef.current.click()}
              style={{ width: 80, height: 80, borderRadius: 14, border: "2px dashed #c7c3ff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", background: "#faf9ff", overflow: "hidden" }}
            >
              {logoPreview
                ? <img src={logoPreview} alt="logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                : <span style={{ fontSize: 28 }}>🏢</span>
              }
            </div>
            <div>
              <button onClick={() => logoRef.current.click()} style={{ padding: "8px 16px", background: "#f0efff", color: "#6c63ff", border: "2px solid #e0ddff", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "inherit" }}>
                📁 Changer le logo
              </button>
              <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>PNG, JPG — Max 2MB</div>
            </div>
          </div>
          <input ref={logoRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleLogo} />
        </div>

        {/* Nom — readonly */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#444", marginBottom: 6, display: "block" }}>🏷️ Nom de la société</label>
          <input value={form.nom} disabled style={{ width: "100%", padding: "12px 16px", border: "2px solid #e2e8f0", borderRadius: 10, fontSize: 14, background: "#f8f8f8", color: "#888", boxSizing: "border-box", fontFamily: "inherit" }} />
          <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>Le nom ne peut pas être modifié</div>
        </div>

        {/* Adresse */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#444", marginBottom: 6, display: "block" }}>📍 Adresse</label>
          <input value={form.adresse} onChange={e => setForm({ ...form, adresse: e.target.value })}
            placeholder="Ex: 12 Rue de la République, Tunis"
            style={{ width: "100%", padding: "12px 16px", border: "2px solid #e2e8f0", borderRadius: 10, fontSize: 14, background: "#fafafa", boxSizing: "border-box", fontFamily: "inherit", outline: "none" }} />
        </div>

        {/* Téléphone */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#444", marginBottom: 6, display: "block" }}>📞 Téléphone</label>
          <input value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })}
            placeholder="+216 xx xxx xxx"
            style={{ width: "100%", padding: "12px 16px", border: "2px solid #e2e8f0", borderRadius: 10, fontSize: 14, background: "#fafafa", boxSizing: "border-box", fontFamily: "inherit", outline: "none" }} />
        </div>

        {/* Buttons */}
        <button onClick={handleSave} style={{ width: "100%", padding: 14, background: "linear-gradient(135deg,#6c63ff,#a78bfa)", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", marginBottom: 10 }}>
          💾 Sauvegarder les modifications
        </button>
        <button onClick={() => window.location.href = "/home"} style={{ width: "100%", padding: 13, background: "#f0efff", color: "#6c63ff", border: "2px solid #e0ddff", borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          ← Retour au tableau de bord
        </button>
      </div>
    </div>
  );
}